import React from "react";
import { Select, InputLabel, FormControl, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const DrinkAndEat = ({ drinkandeat, handleDrinkAndEat }) => {
  const classes = useStyles();

  return (
    <>
      <div className="formStep--wrapper">
        <h2>Trink & Fressverhalten</h2>
        <div className="drinkAndEat--grid">
          <div>
            <h4 className="drinkAndEat--label">Trinken</h4>

            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="drinking-label">Trinken</InputLabel>
              <Select
                className="select"
                autoWidth
                variant="outlined"
                name="behavior"
                labelId="drinking-label"
                id="drinking"
                value={drinkandeat.drinking.behavior}
                onChange={event => {
                  handleDrinkAndEat(event, "drinking");
                }}
                label="Trinken"
              >

                <MenuItem value={1}>Normal</MenuItem>
                <MenuItem value={2}>Mehr</MenuItem>
                <MenuItem value={3}>Weniger</MenuItem>
                <MenuItem value={4}>Überhaupt nicht</MenuItem>
              </Select>
            </FormControl>
            {drinkandeat.drinking.behavior > 1 && (
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="drinkingSince-label">Seit</InputLabel>
                <Select
                  className="select"
                  autoWidth
                  variant="outlined"
                  name="since"
                  labelId="drinkingSince-label"
                  id="drinkingSince"
                  value={drinkandeat.drinking.since}
                  onChange={event => {
                    handleDrinkAndEat(event, "drinking");
                  }}
                  label="Seit"
                >
                  <MenuItem value={1}>Mehr als 6 Stunden</MenuItem>
                  <MenuItem value={2}>Mehr als 12 Stunden</MenuItem>
                  <MenuItem value={3}>Mehr als 24 Stunden</MenuItem>
                </Select>
              </FormControl>
            )}
          </div>

          <div>
            <h4 className="drinkAndEat--label">Fressen</h4>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="eating-label">Fressen</InputLabel>
              <Select
                className="select"
                autoWidth
                variant="outlined"
                name="behavior"
                labelId="eating-label"
                id="eating"
                value={drinkandeat.eating.behavior}
                onChange={event => {
                  handleDrinkAndEat(event, "eating");
                }}
                label="Fressen"
              >
                <MenuItem value={1}>Normal</MenuItem>
                <MenuItem value={2}>Mehr</MenuItem>
                <MenuItem value={3}>Weniger</MenuItem>
                <MenuItem value={4}>Überhaupt nicht</MenuItem>
              </Select>
            </FormControl>
            {drinkandeat.eating.behavior > 1 && (
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="eatingSince-label">Seit</InputLabel>
                <Select
                  className="select"
                  autoWidth
                  variant="outlined"
                  name="since"
                  labelId="eatingSince-label"
                  id="eatingSince"
                  value={drinkandeat.eating.since}
                  onChange={event => {
                    handleDrinkAndEat(event, "eating");
                  }}
                  label="Seit"
                >
                  <MenuItem value={1}>Mehr als 6 Stunden</MenuItem>
                  <MenuItem value={2}>Mehr als 12 Stunden</MenuItem>
                  <MenuItem value={3}>Mehr als 24 Stunden</MenuItem>
                </Select>
              </FormControl>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DrinkAndEat;
